import { Action,action } from 'easy-peasy';

export interface CookiesConsentModel {
  optionalCookiesConsent: boolean;
  cookiesSeen: boolean;
  setOptionalCookiesConsent: Action<CookiesConsentModel, boolean>;
  setCookiesSeen: Action<CookiesConsentModel, boolean>;
}

const cookies: CookiesConsentModel = {
  optionalCookiesConsent: false,
  cookiesSeen: false,

  setOptionalCookiesConsent: action((state, payload) => {
    state.optionalCookiesConsent = payload;
  }),
  setCookiesSeen: action((state, payload) => {
    state.cookiesSeen = payload;
  }),
};

export default cookies;
